import React from 'react'

export const AllContextInjector = ({ children, providers = [] }) => providers.reduce(
  (previousChildren, Provider) => <Provider>{previousChildren}</Provider>,
  children,
)
